import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface BrandAssignment {
    brandId: string;
    isTechnicalSupport: boolean;
    isPriceAndAvailability: boolean;
}

export interface ProductTypeAssignment {
    productTypeId: string;
    isTechnicalSupport: boolean;
    isPriceAndAvailability: boolean;
}

export interface AddOrUpdateEmployeeApiModel {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    title: string;
    branchId: string;
    // branchName: string;
    startDate: string;
    bioSnippet?: string;
    bioFull?: string;
    education: string;
    trainingsAttended: string;
    personalInterests: string;
    isSme: boolean;
    isDsm: boolean;
    isActive: boolean;
    isTextMessageAllowed: boolean;
    photoUrl?: string;
    divisionId?: string;
    BrandIds?: BrandAssignment[];
    ProductTypeIds?: ProductTypeAssignment[];
}

export interface EmployeeModel {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    title: string;
    branchId: string;
    branchName?: string;
    startDate: string;
    bioSnippet?: string;
    bioFull?: string;
    education: string;
    trainingsAttended: string;
    personalInterests: string;
    isSme: boolean;
    isDsm: boolean;
    isActive: boolean;
    isTextMessageAllowed: boolean;
    photoUrl?: string;
    divisionId?: string;
    brandIds?: BrandAssignment[];
    productTypeIds?: ProductTypeAssignment[];
}

export interface EmployeeCollectionModel {
    employeeModels: EmployeeModel[];
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
    };
}

const baseUrl = "/api/v2/centroconnect/sme/admin/employee";

export function addEmployee(model: AddOrUpdateEmployeeApiModel) {
    return post<AddOrUpdateEmployeeApiModel, EmployeeModel>(baseUrl, model as any);
}

export function getEmployeeCollection(page?: number, pageSize?: number,query?: string) {
    const params = new URLSearchParams();
    if (page !== undefined) {
        params.append("page", page.toString());
    }
    if (pageSize !== undefined) {
        params.append("pageSize", pageSize.toString());
    }
     if (query !== undefined) {
        params.append('query', query.trim());
    }
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<EmployeeCollectionModel>(url);
}

export function updateEmployee(model: AddOrUpdateEmployeeApiModel) {
    return patch<any>(baseUrl, model as any) as Promise<EmployeeModel>;
}

export function deleteEmployee(employeeId: string) {
    return del(`${baseUrl}/${employeeId}`) as Promise<void>;
}
export const getEmployeeById = async (employeeId: string): Promise<any> => {
    return get<EmployeeModel>(`${baseUrl}/${employeeId}`);
};
